/**
 * index.ts - Infrastructure preference modules
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export { cachrModule } from './cachr';
export { contextrModule } from './contextr';
export { charactrModule } from './charactr';
export { gittrModule } from './gittr';

import { cachrModule } from './cachr';
import { contextrModule } from './contextr';
import { charactrModule } from './charactr';
import { gittrModule } from './gittr';

export const infrastructureModules = [
  cachrModule,
  contextrModule,
  charactrModule,
  gittrModule
];

export default infrastructureModules;
